import Panel from '@admin/components/panel'
import TeamToken from '@admin/tokens/team'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  title: 't(Payouts)',
  collection: {
    endpoint: `/api/admin/truevail/admin/payouts/${props.payout.id}/payments`,
    table: [
      { label: 't(ID)', key: 'id', collapsing: true, visible: false },
      { label: 't(Team)', key: 'payment.team.title', primary: true, format: (line_item) => (
        <TeamToken { ...line_item.referral } />
      ) },
      { label: 't(Payment)', key: 'payment.amount', collapsing: true, align: 'right', format: 'currency' },
      { label: 't(Commision)', key: 'amount', collapsing: true, align: 'right', format: 'currency' }
    ],
    empty: {
      title: 't(No Payments)',
      text: 't(There are no payments for this payout)',
      svg: 'hand_coins'
    },
    entity: 'payment',
    defaultSort: { key: 'created_at', order: 'desc' },
    onClick: (record) => context.router.push(`/admin/finance/payments/${record.payment.id}`)
  }
})

export default Panel(null, mapPropsToPanel)
